const DIET_KEY = "mycoaching_diet_templates";
const TRAINING_KEY = "mycoaching_training_templates";

function load(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function save(key, templates) {
  localStorage.setItem(key, JSON.stringify(templates));
}

function newId() {
  return `tpl_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export function getDietTemplates() {
  return load(DIET_KEY);
}

export function getTrainingTemplates() {
  return load(TRAINING_KEY);
}

export function saveDietTemplate({ name, data }) {
  const templates = getDietTemplates();
  const template = {
    id: newId(),
    name: name || "Modèle sans nom",
    type: "diet",
    data: {
      title: data.title || "",
      description: data.description || "",
      meals: data.meals || [],
      calories_target: data.calories_target ?? null,
      protein_target: data.protein_target ?? null,
      carbs_target: data.carbs_target ?? null,
      fat_target: data.fat_target ?? null,
    },
    created_at: new Date().toISOString(),
  };
  templates.unshift(template);
  save(DIET_KEY, templates);
  return template;
}

export function saveTrainingTemplate({ name, data }) {
  const templates = getTrainingTemplates();
  const template = {
    id: newId(),
    name: name || "Modèle sans nom",
    type: "training",
    data: {
      title: data.title || "",
      description: data.description || "",
      days: data.days || [],
    },
    created_at: new Date().toISOString(),
  };
  templates.unshift(template);
  save(TRAINING_KEY, templates);
  return template;
}

export function deleteDietTemplate(id) {
  save(DIET_KEY, getDietTemplates().filter((t) => t.id !== id));
}

export function deleteTrainingTemplate(id) {
  save(TRAINING_KEY, getTrainingTemplates().filter((t) => t.id !== id));
}

export function getDietTemplate(id) {
  return getDietTemplates().find((t) => t.id === id) || null;
}

export function getTrainingTemplate(id) {
  return getTrainingTemplates().find((t) => t.id === id) || null;
}